export function getActivityStatusColor(status: string | null | undefined): string {
  if (!status) return 'text-[#b4870b]';
  const u = status.toUpperCase();
  if (u.startsWith('CANCEL') || u === 'NOSHOW') return 'text-[#971b2f]';
  if (u === 'DELIVERED' || u === 'COMPLETED' || u === 'CHECKEDOUT') return 'text-[#325d2d]';
  return 'text-[#b4870b]';
}
